import { TraceContext } from '../tracing/index.js';
export class ScopedLogger {
    $name = 'scoped-logger';
    _entries = [];
    _hasError = false;
    _isDebugEnabled = false;
    _traceId;
    _requestId;
    constructor(config, traceContext) {
        this._isDebugEnabled = config.isDebugEnabled;
        this._traceId = traceContext.traceId;
        this._requestId = traceContext.parentId;
    }
    debug(obj) {
        this._entries.unshift({
            type: 'debug',
            args: {
                timestamp: Date.now(),
                ...obj,
            },
        });
    }
    error(obj) {
        this._entries.unshift({
            type: 'error',
            args: {
                timestamp: Date.now(),
                ...obj,
            },
        });
        this._hasError = true;
    }
    info(obj) {
        this._entries.unshift({
            type: 'info',
            args: {
                timestamp: Date.now(),
                ...obj,
            },
        });
    }
    fork() {
        return new ScopedLogger({ isDebugEnabled: this._isDebugEnabled }, TraceContext.fromTraceIdAndRequestId(this._traceId, this._requestId));
    }
    mergeIn(logger, areLogsAggregated) {
        if (areLogsAggregated) {
            if (logger._hasError) {
                const errorEntry = logger._entries.find((e) => e.type === 'error');
                const trace = logger._entries.reverse().map((e) => e.args);
                const lastEntry = trace[logger._entries.length - 1];
                if (lastEntry) {
                    // @ts-ignore
                    const { location } = lastEntry;
                    // @ts-ignore
                    const { timestamp } = lastEntry;
                    // @ts-ignore
                    const error = errorEntry?.args?.error;
                    this._entries.unshift({
                        type: 'error',
                        args: {
                            location,
                            error,
                            timestamp,
                            trace: JSON.stringify(trace),
                        },
                    });
                }
            }
            else {
                const traceEntries = logger._entries
                    .filter((e) => e.type === 'info' || (this._isDebugEnabled && e.type === 'debug'))
                    .reverse();
                const trace = traceEntries.map((e) => e.args);
                const lastEntry = trace[trace.length - 1];
                if (lastEntry) {
                    // @ts-ignore
                    const location = lastEntry?.location;
                    // @ts-ignore
                    const timestamp = lastEntry?.timestamp;
                    this._entries.unshift({
                        type: 'info',
                        args: {
                            location,
                            timestamp,
                            trace: JSON.stringify(trace),
                        },
                    });
                }
            }
        }
        else {
            this._entries.unshift(...logger._entries);
        }
    }
    print(logger, areLogsAggregated) {
        if (areLogsAggregated) {
            const logs = this.toLog();
            if (logs) {
                if (this._hasError) {
                    logger.error(logs);
                }
                else {
                    logger.info(logs);
                }
            }
        }
        else {
            const logs = this.toLogs();
            for (const log of logs) {
                switch (log.type) {
                    case 'error':
                        logger.error(log);
                        break;
                    case 'debug':
                        logger.debug(log);
                        break;
                    default:
                        logger.info(log);
                        break;
                }
            }
        }
    }
    toLog() {
        if (this._hasError) {
            const error = this._entries.find((e) => e.type === 'error');
            const trace = this._entries.reverse().map((e) => e.args);
            const lastEntry = trace[this._entries.length - 1];
            // @ts-ignore
            const location = lastEntry?.location || '<unknown>';
            // @ts-ignore
            const timestamp = lastEntry?.timestamp || Date.now();
            return {
                traceId: this._traceId,
                requestId: this._requestId,
                location,
                error: error?.args?.error,
                timestamp,
                trace: JSON.stringify(trace),
            };
        }
        const traceEntries = this._entries
            .filter((e) => e.type === 'info' || (this._isDebugEnabled && e.type === 'debug'))
            .reverse();
        const trace = traceEntries.map((e) => e.args);
        const lastEntry = trace[trace.length - 1];
        // @ts-ignore
        const location = lastEntry?.location || '<unknown>';
        // @ts-ignore
        const timestamp = lastEntry?.timestamp || Date.now();
        if (lastEntry) {
            return {
                traceId: this._traceId,
                requestId: this._requestId,
                location,
                timestamp,
                trace: JSON.stringify(trace),
            };
        }
        return null;
    }
    toLogs() {
        if (this._hasError) {
            const logs = this._entries.reverse().map((e) => {
                // @ts-ignore
                const location = e.args.location || '<unknown>';
                const log = {
                    ...e.args,
                    type: e.type,
                    location,
                    traceId: this._traceId,
                    requestId: this._requestId,
                };
                return log;
            });
            return logs;
        }
        const relevantEntries = this._entries
            .filter((e) => e.type === 'info' || (this._isDebugEnabled && e.type === 'debug'))
            .reverse();
        const logs = relevantEntries.map((e) => {
            // @ts-ignore
            const location = e.args.location || '<unknown>';
            const log = {
                ...e.args,
                type: e.type,
                location,
                traceId: this._traceId,
                requestId: this._requestId,
            };
            return log;
        });
        return logs;
    }
}
//# sourceMappingURL=scoped-logger.js.map